/**
 * Stores and exposes the volume value throughout the app. This volume value
 * is assumed to be on a 100 point scale and is shared between video and
 * audio players. Note that audio volume _gain_ is handled by the player and
 * is not applied to this value.
 *
 * @module reducers/Volume
 */
import { Map } from 'immutable';
import { REHYDRATE } from 'redux-persist/constants';

import { VolumeKeys } from './constants';
import * as D from './deps';

const INITIAL_STATE = Map({
  [VolumeKeys.VOLUME]: D.PlaybackConstants.VolumeConstants.DEFAULT_VOLUME,
  [VolumeKeys.MUTED]: false,
});

// VOLUME REDUCER
export default D.createReducer(INITIAL_STATE, {
  [D.Constants.Volume.VolumeActions.SET_VOLUME]: setVolume,
  [D.Constants.Volume.VolumeActions.SET_MUTED]: setMuted,
  [REHYDRATE]: onRehydrate,
});

export const VolumeFilter = D.createFilter({
  reducer: 'volume',
  keys: [VolumeKeys.VOLUME],
  defaults: INITIAL_STATE,
  // to ensure volume from persisted state is never 0
  outbound(state) {
    if (!state) return INITIAL_STATE;
    if (state.get(VolumeKeys.VOLUME) === 0) {
      return state.set(
        VolumeKeys.VOLUME,
        D.PlaybackConstants.VolumeConstants.DEFAULT_UNMUTE_VOLUME,
      );
    }
    return state;
  },
});

// CASE FUNCTIONS

function setVolume(state, { payload }) {
  return state.set(VolumeKeys.VOLUME, payload.volume);
}

function setMuted(state, { payload }) {
  return state.set(VolumeKeys.MUTED, !!payload.muted);
}

function onRehydrate(state, action) {
  return action.payload.volume || state;
}
